
function applyPromocode(obj) {

    if (isRateOfferValid(obj) && obj.code) {

        try {

            updateSearchRoomAvailabilityByRateOffer([{name: 'rateOfferCode', value: obj.code}, {name: 'rateOfferType', value: 1}, {name: 'eventCode', value: obj.eventCode}, {name: 'isCleanupHighlightProduct', value: obj.isCleanupHighlightProduct}]);

        } catch (exception) {
        }
    }
}


function applyRateOffer(obj) {
    
    if (isRateOfferValid(obj)) {

        try {
            
            updateSearchRoomAvailabilityByRateOffer([{name: 'rateOfferCode', value: obj.code}, 
                                                     {name: 'rateOfferType', value: obj.type}, 
                                                     {name: 'eventCode', value: obj.eventCode}, 
                                                     {name: 'isCleanupHighlightProduct', value: obj.isCleanupHighlightProduct}]);
            
        } catch (exception) {
        }
    }
}

function isRateOfferValid(obj) {

    if (obj === null) {
        return false;
    }
    return ((typeof obj !== 'function') && (typeof obj === 'object'));
}